import "./DataCuadrantes.scss";
import { useEffect, useState, useContext, useCallback } from "react";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, Button, CircularProgress, TextField, IconButton, Menu } from '@mui/material';
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { AuthContext } from "../../context/AuthContext";
import { fetchUserData, fetchTiendasPorCampoCliente } from "../../components/admin/firestoreService";
import { db } from '../../firebase';
import {
  createCuadrante,
  obtenerTurnosPorCuadrante,
  obtenerVigilantePorCodigoPersona,
  obtenerDetallesServicio,
  fetchYGuardarHorariosOperativos,
  obtenerHorariosOperativosGuardados,
  convertirHorariosATurnos,
  registrarTurnosPrevisualizados,
  buscarCuadrantePorMesAño
} from "./data/FirestoreCuadrantes";
import profiler from './utils/PerformanceProfiler';
import { handleFileUpload, exportarCuadrante } from './utils/cuadrante-utils';
import CreateTurno from './modals/CreateTurno';
import ActualizarTurno from './modals/Actualizarturno';
import GridView from './grid/GridView';
import ExportModal from './modals/ExportModal';
import EnhancedAutoScheduler from './scheduler/AutoScheduler';
import ApiTesterComponent from './test/ApiTesterComponent';
import ClienteSearchSingle from '../../utils/ClienteSearchSingle';
import ServicioSearchSingle from '../../utils/ServicioSearchSingle';
import CuadranteConfig from './config/CuadranteConfig';
import CuadranteValidator from './config/CuadranteValidator';
import CuadranteUpdater from './config/CuadranteUpdater';
import FreematicaTramos from './freematica/FreematicaTramos';
import EjemploBusquedaServicios from './preview/EjemploBusquedaServicios';
import DetallesTurnosGenerados from './preview/DetallesTurnosGenerados';
import ResumenTurnosPrevisualizacion from './preview/ResumenTurnosPrevisualizacion';
import RegistroDirectoTurnos from './preview/RegistroDirectoTurnos';
import PruebaConversionTurnos from './preview/PruebaConversionTurnos';
import VisualizarCuadrantes from './visualizar/VisualizarCuadrantes';
import AsignacionIA from './ai/AsignacionIA';

const DataCuadrantes = () => {
  // Estados existentes
  const [clientes, setClientes] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState('');
  const [selectedServicio, setSelectedServicio] = useState('');
  const [userData, setUserData] = useState({});
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [serviciosFiltrados, setServiciosFiltrados] = useState([]);
  const [events, setEvents] = useState([]);
  const [mostrarFormularioTurno, setMostrarFormularioTurno] = useState(false);
  const [cuadranteId, setCuadranteId] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [turnoId, setTurnoId] = useState('');
  const [eventoTurnoSeleccionado, setEventoTurnoSeleccionado] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const [importError, setImportError] = useState(null);
  const [mesExportacion, setMesExportacion] = useState(new Date());
  const [exportModalOpen, setExportModalOpen] = useState(false);

  // Estados de carga
  const [isLoadingClientes, setIsLoadingClientes] = useState(true);
  const [isLoadingServicios, setIsLoadingServicios] = useState(true);
  
  // Estados para búsqueda de clientes
  const [clientesSearchTerm, setClientesSearchTerm] = useState('');
  const [clientesBuscados, setClientesBuscados] = useState([]);
  const [isSearchingClientes, setIsSearchingClientes] = useState(false);
  
  // Estados para la nueva funcionalidad de validación
  const [showInstructions, setShowInstructions] = useState(false);
  const [showConfigPanel, setShowConfigPanel] = useState(false);
  const [showValidator, setShowValidator] = useState(false);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [validationResults, setValidationResults] = useState(null);
  const [configuraciones, setConfiguraciones] = useState([]);
  
  // Estados para la funcionalidad de actualización de cuadrantes
  const [showCuadranteUpdater, setShowCuadranteUpdater] = useState(false);
  const [updateResult, setUpdateResult] = useState(null);
  
  // Estados para la funcionalidad de tramos de Freematica
  const [showFreematicaTramos, setShowFreematicaTramos] = useState(false);
  
  // Estado para la funcionalidad de asignación con IA
  const [showAsignacionIA, setShowAsignacionIA] = useState(false);
  
  // Estados para fetch de horarios operativos de Freematica
  const [isFetchingHorarios, setIsFetchingHorarios] = useState(false);
  const [fetchHorariosResult, setFetchHorariosResult] = useState(null);
  const [horariosOperativos, setHorariosOperativos] = useState([]);
  const [filtrosContratos, setFiltrosContratos] = useState('');
  const [empresaTest, setEmpresaTest] = useState('0001');

  // Estados para mes/año personalizado
  const fechaActual = new Date();
  const [mesPersonalizado, setMesPersonalizado] = useState(fechaActual.getMonth() + 1); // 1-12
  const [añoPersonalizado, setAñoPersonalizado] = useState(fechaActual.getFullYear());
  
  // Estado para configuración de festivos (múltiples selecciones)
  const [tiposFestivosSeleccionados, setTiposFestivosSeleccionados] = useState([]); // Array de: 'nacionales', 'domingos', 'sabados'
  
  // Estados para obtener festivos desde Freematica
  const [cargarFestivosFreematica, setCargarFestivosFreematica] = useState(true); // Checkbox para cargar festivos
  const [festivosContrato, setFestivosContrato] = useState([]); // Festivos obtenidos del contrato
  const [festivosInfo, setFestivosInfo] = useState(null); // Info adicional sobre los festivos
  
  // Estados para UI mejorada
  const [mostrarMenuConfiguracion, setMostrarMenuConfiguracion] = useState(null);

  const { currentService, currentUser, adminData } = useContext(AuthContext);

  // Función para buscar clientes en Firebase con índices
  const buscarClientesEnFirebase = useCallback(async (searchTerm) => {
    if (!currentService || !searchTerm.trim()) return [];
    
    try {
      const clientesRef = collection(db, 'servicios', currentService.id, 'clientes');
      const q = query(
        clientesRef,
        where('nombre', '>=', searchTerm.trim()),
        where('nombre', '<=', searchTerm.trim() + '\uf8ff'),
        orderBy('nombre'),
        limit(50)
      );
      
      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
      console.error('Error buscando clientes en Firebase:', error);
      return [];
    }
  }, [currentService]);

  // Effect para cargar datos de usuario
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (currentUser && currentService) {
          fetchUserData(currentUser, currentService)
            .then(setUserData)
            .catch(console.error);
        }
      } catch (error) {
        console.warn("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [currentUser, currentService]); 




  // Effect para cargar horarios operativos guardados
  useEffect(() => {
    if (currentService?.id) {
      cargarHorariosOperativosGuardados();
    }
  }, [currentService?.id]);

  // Effect para filtrar servicios por cliente seleccionado
  useEffect(() => {
    if (clienteSeleccionado && currentService) {
      fetchTiendasPorCampoCliente([clienteSeleccionado], currentService)
        .then(setServiciosFiltrados)
        .catch(console.error);
    }
  }, [clienteSeleccionado, currentService]);

  // Effect existente para cargar turnos del cuadrante
  useEffect(() => {
    const fetchTurnosCuadrante = async () => {
      try {
        if (cuadranteId) {
          const turnos = await obtenerTurnosPorCuadrante(cuadranteId, currentService);

          const eventos = await Promise.all(
            turnos.map(async (turno) => {
              // Crear fechas correctamente
              const [year, month, day] = turno.fecha.split('-');
              const [horaInicio] = turno.inicioTurno.split(':');
              const [horaFin] = turno.finTurno.split(':');

              const start = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(horaInicio));
              const end = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(horaFin));

              if (parseInt(horaFin) < parseInt(horaInicio)) {
                end.setDate(end.getDate() + 1);
              }

              // Verificar si el turno está sin asignar
              const isSinAsignar = turno.sinAsignar || !turno.vigilante || turno.vigilante === '' || turno.vigilante === null || turno.vigilante === undefined;

              if (isSinAsignar) {
                // Para turnos sin asignar
                return {
                  id: turno.id,
                  title: 'Sin Asignar',
                  start: start,
                  end: end,
                  turno: turno.turno || 'Sin turno',
                  vigilante: '',
                  vigilanteId: null,
                  fecha: turno.fecha,
                  inicioTurno: turno.inicioTurno,
                  finTurno: turno.finTurno,
                  persona: 'Sin asignar',
                  sinAsignar: true
                };
              } else {
                // Para turnos asignados
                try {
                  const vigilanteData = await obtenerVigilantePorCodigoPersona(turno.vigilante, currentService);
                  return {
                    id: turno.id,
                    title: vigilanteData ? `${vigilanteData.nombre} ${vigilanteData.apellidos}` : `Sin usuario (${turno.vigilante})`,
                    start: start,
                    end: end,
                    turno: turno.turno || 'Sin turno',
                    vigilante: turno.vigilante, // Código de persona
                    vigilanteId: vigilanteData ? vigilanteData.id : null, // ID de Firestore
                    fecha: turno.fecha,
                    inicioTurno: turno.inicioTurno,
                    finTurno: turno.finTurno,
                    persona: vigilanteData ? `${vigilanteData.nombre} ${vigilanteData.apellidos}` : `Código: ${turno.vigilante}`,
                    sinAsignar: false
                  };
                } catch (error) {
                  console.warn("Error procesando turno asignado:", turno, error);
                  return {
                    id: turno.id,
                    title: `Sin usuario (${turno.vigilante})`,
                    start: start,
                    end: end,
                    turno: turno.turno || 'Sin turno',
                    vigilante: turno.vigilante,
                    vigilanteId: null,
                    fecha: turno.fecha,
                    inicioTurno: turno.inicioTurno,
                    finTurno: turno.finTurno,
                    persona: `Código: ${turno.vigilante}`,
                    sinAsignar: false
                  };
                }
              }
            })
          );

          const eventosValidos = eventos.filter(evento => evento !== null);
          setEvents(eventosValidos);
        }
      } catch (error) {
        console.warn('Error al obtener los turnos del cuadrante:', error);
      }
    };

    fetchTurnosCuadrante();
  }, [cuadranteId, currentService]);

  // Handlers existentes (sin cambios significativos)
  const handleFileUploadWrapper = (event) => {
    handleFileUpload(event, cuadranteId, currentService, setIsImporting, setImportError, setEvents);
  };

  const handleExportarCuadrante = () => {
    setExportModalOpen(true);
  };

  const handleExportWithDesc = async (descContrato) => {
    try {
      await exportarCuadrante(events, mesExportacion, currentService, selectedServicio, descContrato);
      setExportModalOpen(false);
    } catch (error) {
      alert('Error al exportar el cuadrante');
    }
  };

  const handleMesChange = async (nuevaFecha) => {
    setMesExportacion(nuevaFecha);
    
    // Buscar el cuadrante correspondiente al nuevo mes/año
    if (currentService?.id && selectedServicio && nuevaFecha) {
      const mes = nuevaFecha.getMonth() + 1;
      const año = nuevaFecha.getFullYear();
      const mesAñoKey = `${año}-${String(mes).padStart(2, '0')}`;
      
      console.log(`📅 Cambiando a mes/año: ${mesAñoKey}`);
      console.log(`🔍 Buscando cuadrante para servicio: ${selectedServicio}`);
      
      try {
        const cuadranteEncontrado = await buscarCuadrantePorMesAño(
          currentService.id,
          selectedServicio,
          mesAñoKey
        );
        
        if (cuadranteEncontrado) {
          console.log(`✅ Cuadrante encontrado para ${mesAñoKey}: ${cuadranteEncontrado}`);
          setCuadranteId(cuadranteEncontrado);
          setMesPersonalizado(mes);
          setAñoPersonalizado(año);
          
          // Cargar los eventos del nuevo cuadrante
          const eventosCargados = await obtenerTurnosPorCuadrante(cuadranteEncontrado, currentService);
          setEvents(eventosCargados || []);
          console.log(`📊 Cargados ${eventosCargados?.length || 0} eventos para ${mesAñoKey}`);
        } else {
          console.log(`⚠️ No se encontró cuadrante para ${mesAñoKey}`);
          setEvents([]);
          setCuadranteId(null);
        }
      } catch (error) {
        console.error('❌ Error al cambiar de mes:', error);
      }
    }
  };

  const handleClienteChange = (clienteSeleccionado) => {
    setSelectedCliente(clienteSeleccionado);
    setClienteSeleccionado(clienteSeleccionado);

    // Filtrar y establecer las tiendas basadas en el cliente seleccionado
    const nuevasTiendasFiltradas = servicios.filter(servicio =>
      servicio?.cliente === clienteSeleccionado
    );

    setServiciosFiltrados(nuevasTiendasFiltradas);
    // Limpiar la selección de servicio cuando cambia el cliente
    setSelectedServicio('');
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = async () => {
    // Vuelve a obtener los turnos del cuadrante actualizado
    const turnos = await obtenerTurnosPorCuadrante(cuadranteId, currentService);

    // Transforma los turnos en eventos compatibles con GridView
    const eventos = turnos.map((turno) => ({
      id: turno.id,
      usuarios: turno.vigilante,
      start: turno.inicioTurnoTimestamp,
      end: turno.finTurnoTimestamp,
      turno: turno.turno || 'Sin turno',
    }));

    // Actualiza el estado de los eventos con los eventos actualizados
    setEvents(eventos);
    setModalOpen(false);
    handleUpdateTurnoComplete();
  };

  const handleServiciosChange = (servicioSeleccionado) => {
    setSelectedServicio(servicioSeleccionado);

    // Verificar servicio seleccionado
    if (servicioSeleccionado && servicioSeleccionado.length > 0) {
      try {
        obtenerDetallesServicio(servicioSeleccionado, currentService);
      } catch (error) {
        console.warn('Error al obtener detalles de servicio:', error);
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validaciones antes de proceder
    if (!currentService || !currentService.id) {
      console.error('Error: No hay servicio activo seleccionado');
      alert('Error: No hay servicio activo seleccionado. Por favor, selecciona un servicio.');
      return;
    }

    if (!currentUser || !currentUser.uid) {
      console.error('Error: No hay usuario autenticado');
      alert('Error: No hay usuario autenticado. Por favor, inicia sesión.');
      return;
    }

    if (selectedCliente === '') {
      console.error('Error: No hay cliente seleccionado');
      alert('Error: Debes seleccionar al menos un cliente.');
      return;
    }

    if (selectedServicio === '') {
      console.error('Error: No hay servicio seleccionado');
      alert('Error: Debes seleccionar al menos un servicio.');
      return;
    }

    try {
      console.log('Creando cuadrante con:', {
        cliente: selectedCliente,
        servicio: currentService.id,
        servicioSeleccionado: selectedServicio,
        usuario: currentUser.uid
      });

      const cuadranteId = await createCuadrante(selectedCliente, currentService, selectedServicio, currentUser.uid);
      setCuadranteId(cuadranteId);
      setMostrarFormularioTurno(true);

      const turnos = await obtenerTurnosPorCuadrante(cuadranteId, currentService);

      const eventos = await Promise.all(
        turnos.map(async (turno) => {
          if (turno.vigilante) {
            const vigilanteData = await obtenerVigilantePorCodigoPersona(turno.vigilante, currentService);

            // Crear fechas correctamente
            const [year, month, day] = turno.fecha.split('-');
            const [horaInicio] = turno.inicioTurno.split(':');
            const [horaFin] = turno.finTurno.split(':');

            const start = new Date(year, month - 1, day, parseInt(horaInicio));
            const end = new Date(year, month - 1, day, parseInt(horaFin));

            // Si la hora de fin es menor que la de inicio, añadir un día
            if (end < start) {
              end.setDate(end.getDate() + 1);
            }

            return {
              id: turno.id,
              title: vigilanteData ? `${vigilanteData.nombre} ${vigilanteData.apellidos}` : 'Turno sin usuario',
              start: start,
              end: end,
            };
          }
          return null;
        })
      );

      const eventosValidos = eventos.filter(evento => evento !== null);
      setEvents(eventosValidos);
    } catch (error) {
      console.error('Error al crear el cuadrante:', error);
      alert(`Error al crear el cuadrante: ${error.message}`);
    }
  };

  const handleEventClick = (turnoId) => {
    setEventoTurnoSeleccionado(turnoId);
    handleOpenModal();
  };

  const handleUpdateTurnoComplete = () => {
    // Limpiar la selección de turno
    setEventoTurnoSeleccionado(null);
  };

  // Funciones para fetch de horarios operativos de Freematica
  const handleFetchHorariosOperativos = async () => {
    if (!currentService?.id) {
      alert('Error: No hay servicio activo seleccionado');
      return;
    }

    if (!filtrosContratos.trim()) {
      alert('Error: Debe especificar un contrato/servicio para cargar el horario');
      return;
    }

    setIsFetchingHorarios(true);
    setFetchHorariosResult(null);

    // 📊 PROFILING: Iniciar sesión para creación de cuadrante
    profiler.startSession(`CrearCuadrante_${filtrosContratos}_${Date.now()}`, {
      contrato: filtrosContratos,
      mes: mesPersonalizado,
      año: añoPersonalizado,
      tipo: 'creacion_nuevo_cuadrante'
    });

    try {
      console.log('🔄 Iniciando fetch de horarios operativos...');
      console.log(`📅 Mes seleccionado: ${mesPersonalizado}, Año seleccionado: ${añoPersonalizado}`);
      
      // Convertir filtrosContratos de string a array - solo un contrato/servicio específico
      const filtrosArray = filtrosContratos.trim() 
        ? filtrosContratos.split(',').map(filtro => filtro.trim()).filter(filtro => filtro)
        : [];

      // Validar formato de filtros
      const filtrosInvalidos = filtrosArray.filter(filtro => !filtro.includes('/') || filtro.split('/').length !== 2);
      if (filtrosInvalidos.length > 0) {
        throw new Error(`Formato inválido en filtros: ${filtrosInvalidos.join(', ')}. Use formato: contrato/servicio`);
      }

      // Validar que solo se proporcione un contrato/servicio
      if (filtrosArray.length > 1) {
        throw new Error('Solo se puede cargar un contrato/servicio a la vez. Use formato: contrato/servicio');
      }

      // 🆕 VALIDAR FECHAS DEL CONTRATO
      console.log('📅 Validando fechas del contrato antes de cargar...');
      const { validarFechasContrato } = await import('./services/ApiMarcajes');
      const validacionFechas = await validarFechasContrato(
        filtrosArray[0], 
        mesPersonalizado, 
        añoPersonalizado,
        empresaTest || undefined
      );
      
      if (!validacionFechas.esValido) {
        setFetchHorariosResult({
          success: false,
          message: validacionFechas.mensaje,
          data: {
            fechaAlta: validacionFechas.fechaAlta,
            fechaFin: validacionFechas.fechaFin,
            contratoInfo: validacionFechas.contratoInfo
          }
        });
        setIsFetchingHorarios(false);
        return;
      }
      
      console.log('✅ Validación de fechas exitosa:', validacionFechas.mensaje);

      // 🎉 OBTENER FESTIVOS DEL CONTRATO (si está activado el checkbox)
      if (cargarFestivosFreematica) {
        try {
          console.log('📅 Obteniendo festivos del contrato desde Freematica...');
          const { obtenerFestivosContrato } = await import('./services/ApiMarcajes');
          
          const festivosData = await obtenerFestivosContrato(
            filtrosArray[0],
            añoPersonalizado,
            empresaTest || undefined
          );
          
          if (festivosData.errorCode === "200") {
            setFestivosContrato(festivosData.data.festivos);
            setFestivosInfo({
              codigoCalendario: festivosData.data.codigoCalendario,
              descripcion: festivosData.data.descripcion,
              totalFestivos: festivosData.data.totalFestivos
            });
            console.log(`✅ Festivos obtenidos: ${festivosData.data.totalFestivos} festivos para ${añoPersonalizado}`);
            console.log(`📋 Calendario: ${festivosData.data.codigoCalendario} - ${festivosData.data.descripcion}`);
          } else {
            console.warn('⚠️ No se pudieron obtener festivos:', festivosData.errorMessage);
            setFestivosContrato([]);
            setFestivosInfo(null);
          }
        } catch (errorFestivos) {
          console.error('❌ Error al obtener festivos:', errorFestivos);
          // No detener el proceso por error en festivos
          setFestivosContrato([]);
          setFestivosInfo(null);
        }
      } else {
        console.log('ℹ️ Carga de festivos desactivada');
        setFestivosContrato([]);
        setFestivosInfo(null);
      }

      const debeGenerarTurnos = true;
      console.log(`📊 Parámetros para fetchYGuardarHorariosOperativos:`, {
        serviceId: currentService.id,
        filtrosArray,
        empresa: empresaTest || null,
        userId: currentUser?.uid || null,
        generarTurnos: debeGenerarTurnos,
        mesPersonalizado,
        añoPersonalizado
      });

      // 📊 PROFILING: Medir fetch desde Freematica
      const fetchId = profiler.startMeasurement('00_FetchDesdeFreematica', {
        filtros: filtrosArray.length,
        mes: mesPersonalizado,
        año: añoPersonalizado
      });

      const resultado = await fetchYGuardarHorariosOperativos(
        currentService.id,
        filtrosArray,
        empresaTest || null, // empresa de prueba
        currentUser?.uid || null, // user ID
        debeGenerarTurnos, // generar turnos (siempre true en Modo Nuevo)
        mesPersonalizado, // mes personalizado (1-12)
        añoPersonalizado // año personalizado
      );

      profiler.endMeasurement(fetchId, {
        horariosObtenidos: resultado.data?.horariosOperativosCount || 0
      });

      setFetchHorariosResult(resultado);
      
      if (resultado.success) {
        console.log('✅ Fetch de horarios operativos completado exitosamente');
        
        // 📊 PROFILING: Medir conversión de horarios a cuadrante
        const conversionId = profiler.startMeasurement('01_ConvertirYCrearCuadrante', {
          contratoServicio: filtrosContratos
        });
        
        // Recargar horarios guardados
        await cargarHorariosOperativosGuardados();
        
        // Automáticamente convertir horarios a turnos y crear cuadrante
        console.log('🔄 Convirtiendo horarios a cuadrante automáticamente...');
        await convertirHorariosACuadrante();
        
        profiler.endMeasurement(conversionId);
      } else {
        console.error('❌ Error en fetch de horarios operativos:', resultado.message);
        
        // Si el error es por duplicados, buscar y cargar el cuadrante existente
        if (resultado.data?.evitadoDuplicados && resultado.data?.mesAño) {
          console.log('🔍 Detectados turnos duplicados. Buscando cuadrante existente para cargar...');
          const mesAñoKey = resultado.data.mesAño;
          
          try {
            // Extraer contrato y servicio del filtrosContratos
            const [contratoInput, servicioInput] = filtrosArray[0].split('/');
            
            // Buscar cuadrantes con contrato + servicio + mes/año (más preciso)
            const cuadrantesQuery = query(
              collection(db, 'servicios', currentService.id, 'cuadrantes'),
              where('_freematica_contrato', '==', contratoInput),
              where('_freematica_servicio', '==', servicioInput),
              where('_freematica_mes_año', '==', mesAñoKey)
            );
            
            console.log(`🔍 Buscando cuadrante con: contrato=${contratoInput}, servicio=${servicioInput}, mes/año=${mesAñoKey}`);
            
            const cuadrantesSnapshot = await getDocs(cuadrantesQuery);
            
            if (!cuadrantesSnapshot.empty) {
              const cuadranteDoc = cuadrantesSnapshot.docs[0];
              const cuadranteId = cuadranteDoc.id;
              const cuadranteData = cuadranteDoc.data();
              
              console.log('✅ Cuadrante existente encontrado:', cuadranteId);
              console.log(`   Contrato: ${cuadranteData._freematica_contrato}, Servicio: ${cuadranteData._freematica_servicio}`);
              
              // Establecer el cuadranteId para cargar los turnos
              setCuadranteId(cuadranteId);
              // Sincronizar mes/año mostrado con el cuadrante cargado (ej. "2025-2" → febrero 2025)
              const [añoStr, mesStr] = String(mesAñoKey).split('-');
              const añoNum = parseInt(añoStr, 10);
              const mesNum = parseInt(mesStr, 10);
              if (!Number.isNaN(añoNum)) setAñoPersonalizado(añoNum);
              if (!Number.isNaN(mesNum)) setMesPersonalizado(mesNum);
              
              // Establecer el servicioId si está disponible
              if (cuadranteData.servicioId) {
                setSelectedServicio(cuadranteData.servicioId);
              }
              
              // Actualizar el resultado para mostrar éxito
              setFetchHorariosResult({
                success: true,
                message: `Cuadrante existente cargado: ${contratoInput}/${servicioInput} para ${mesAñoKey}`,
                data: {
                  cuadranteId: cuadranteId,
                  mesAño: mesAñoKey,
                  contrato: contratoInput,
                  servicio: servicioInput,
                  cargadoDesdeExistente: true
                }
              });
            } else {
              console.warn(`⚠️ No se encontró cuadrante para ${contratoInput}/${servicioInput} en ${mesAñoKey}`);
              setFetchHorariosResult({
                success: false,
                message: `No se encontró cuadrante para ${contratoInput}/${servicioInput} en ${mesAñoKey}. Los turnos existen pero no están agrupados en un cuadrante.`,
                data: null
              });
            }
          } catch (error) {
            console.error('❌ Error buscando cuadrante existente:', error);
          }
        }
      }

    } catch (error) {
      console.error('❌ Error general en fetch de horarios operativos:', error);
      setFetchHorariosResult({
        success: false,
        message: `Error: ${error.message}`,
        data: null
      });
      
      // 📊 PROFILING: En caso de error, finalizar sesión
      profiler.endSession();
    } finally {
      setIsFetchingHorarios(false);
      
      // 📊 PROFILING: NO finalizar sesión aquí si fue exitoso
      // GridView continuará la sesión para medir la carga de turnos
      // Solo finalizamos en catch (error) o cuando GridView termine
    }
  };

  const cargarHorariosOperativosGuardados = async () => {
    if (!currentService?.id) return;

    try {
      const horarios = await obtenerHorariosOperativosGuardados(currentService.id);
      
      // Filtrar solo el horario del contrato/servicio específico
      let horariosFiltrados = horarios;
      if (filtrosContratos.trim()) {
        const contratoServicioEspecifico = filtrosContratos.trim();
        horariosFiltrados = horarios.filter(horario => 
          `${horario.contrato}/${horario.servicio}` === contratoServicioEspecifico
        );
        console.log(`📋 Filtrados ${horariosFiltrados.length} horarios para ${contratoServicioEspecifico} de ${horarios.length} totales`);
      }
      
      setHorariosOperativos(horariosFiltrados);
      console.log(`📋 Cargados ${horariosFiltrados.length} horarios operativos guardados`);
    } catch (error) {
      console.error('❌ Error al cargar horarios operativos guardados:', error);
    }
  };

  // Función para convertir automáticamente horarios a cuadrante
  const convertirHorariosACuadrante = async () => {
    if (!currentService?.id || !currentUser?.uid || !filtrosContratos.trim()) {
      console.warn('⚠️ No se puede convertir horarios a cuadrante: faltan datos requeridos');
      return;
    }

    try {
      console.log('🔄 Iniciando conversión automática de horarios a cuadrante...');
      
      // 1. Obtener horarios filtrados
      const horariosFiltrados = horariosOperativos.filter(horario => 
        `${horario.contrato}/${horario.servicio}` === filtrosContratos.trim()
      );

      if (horariosFiltrados.length === 0) {
        console.warn('⚠️ No hay horarios para convertir');
        return;
      }

      // 2. Convertir horarios a turnos
      console.log('🔄 Convirtiendo horarios a turnos...');
      const registrosIndividuales = horariosFiltrados.flatMap(h => h.registros);
      // console.log(`📊 Total de registros individuales a procesar: ${registrosIndividuales.length}`);
      // console.log(`📋 Primeros 3 registros:`, registrosIndividuales.slice(0, 3));
      // console.log(`📅 Usando mes/año seleccionado: ${mesPersonalizado}/${añoPersonalizado}`);
      
      const turnos = await convertirHorariosATurnos(
        registrosIndividuales, 
        currentService.id,
        empresaTest || '0001', // empresa
        mesPersonalizado, // mes personalizado
        añoPersonalizado // año personalizado
      );

      if (turnos.length === 0) {
        console.warn('⚠️ No se generaron turnos');
        return;
      }

      // 3. Registrar turnos y crear cuadrante
      console.log('🔄 Registrando turnos y creando cuadrante...');
      
      const resultado = await registrarTurnosPrevisualizados(
        turnos, 
        currentService.id, 
        currentUser.uid,
        mesPersonalizado, // mes personalizado
        añoPersonalizado // año personalizado
      );

      if (resultado.success) {
        console.log('✅ Cuadrante creado automáticamente:', resultado.data);
        
        // 4. Establecer el cuadranteId para mostrar en GridView
        if (resultado.data?.cuadranteId) {
          setCuadranteId(resultado.data.cuadranteId);
          console.log('✅ Cuadrante establecido:', resultado.data.cuadranteId);
          
          // 5. Cargar eventos (turnos) para pasarlos a GridView
          console.log('📥 Cargando eventos del cuadrante para GridView...');
          const turnosCargados = await obtenerTurnosPorCuadrante(resultado.data.cuadranteId, currentService);
          const eventosParaCalendario = turnosCargados.map(turno => ({
            id: turno.id,
            title: turno.title || 'Sin asignar',
            start: turno.start,
            end: turno.end,
            fecha: turno.fecha,
            inicioTurno: turno.inicioTurno,
            finTurno: turno.finTurno,
            turno: turno.turno,
            vigilante: turno.vigilante || '',
            sinAsignar: turno.sinAsignar || false
          }));
          setEvents(eventosParaCalendario);
          console.log(`✅ ${eventosParaCalendario.length} eventos cargados para GridView`);
        }
        
        // 6. Extraer y guardar el servicioId de los turnos para poder buscar cuadrantes por mes
        if (turnos.length > 0 && turnos[0].servicioId && turnos[0].servicioId[0]) {
          const servicioIdExtraido = turnos[0].servicioId[0];
          setSelectedServicio(servicioIdExtraido);
          console.log('📋 Servicio establecido:', servicioIdExtraido);
        }
        
      } else {
        console.error('❌ Error creando cuadrante:', resultado.message);
      }

    } catch (error) {
      console.error('❌ Error en conversión automática:', error);
    }
  };

  // Función para probar la conexión con la API
  const handleTestConnection = async () => {
    try {
      console.log('🧪 Probando conexión con la API de Freematica...');
      
      // Probar sin filtros primero
      const resultado = await fetchYGuardarHorariosOperativos(
        currentService.id,
        [], // Sin filtros
        empresaTest || null
      );
      
      console.log('🧪 Resultado de prueba:', resultado);
      
      if (resultado.success) {
        alert('✅ Conexión exitosa con la API de Freematica');
      } else {
        alert(`❌ Error en la conexión: ${resultado.message}`);
      }
      
    } catch (error) {
      console.error('🧪 Error en prueba de conexión:', error);
      alert(`❌ Error en prueba de conexión: ${error.message}`);
    }
  };

  // Función para mostrar información de debugging
  const handleShowDebugInfo = () => {
    const debugInfo = `
🔧 HEADERS QUE SE ENVÍAN DESDE EL FRONTEND (Empresa: ${empresaTest}):
{
  "x-auth-token": "6075893bb0224601a40f5e9fd1723864",
  "x-auth-app": "87452890|6484502060e844cdba2cc6d5ab8c02a2",
  "x-auth-organization": "0109",
  "x-auth-company": "${empresaTest}",
  "x-auth-session": "6075893bb0224601a40f5e9fd1723864",
  "Content-Type": "application/json; charset=utf-8"
}

🔧 ERROR ACTUAL: "Header X-AUTH-COMPANY no válido"
🔧 EMPRESA ACTUAL: ${empresaTest}

🧪 EMPRESAS PARA PROBAR:
- 0001 (actual)
- 0040 (muy común)
- 0002, 0003, 0004, 0005

📋 INSTRUCCIONES:
1. Prueba diferentes empresas usando los botones
2. Usa "Probar Conexión" para cada empresa
3. Revisa la consola para ver los headers exactos
4. Compara con tu curl que funciona
    `;
    
    console.log(debugInfo);
    alert(`🔧 Debug info mostrada en consola. Empresa actual: ${empresaTest}. Prueba diferentes empresas.`);
  };

  const handleTurnoActualizado = async () => {
    try {
      // Recargar turnos del cuadrante
      await fetchTurnosCuadrante();
      
      // Ejecutar validación automática si hay configuración seleccionada
      if (selectedConfig && cuadranteId) {
        await ejecutarValidacionAutomatica();
      }
      
      // Cerrar modal
      setModalOpen(false);
      setMostrarFormularioTurno(false);
      setEventoTurnoSeleccionado(null);
    } catch (error) {
      console.error('Error al actualizar turno:', error);
    }
  };

  const handleTramoCreado = async () => {
    try {
      // Recargar turnos del cuadrante
      await fetchTurnosCuadrante();
      
      // Ejecutar validación automática si hay configuración seleccionada
      if (selectedConfig && cuadranteId) {
        await ejecutarValidacionAutomatica();
      }
      
      // Cerrar modal
      setModalOpen(false);
      setMostrarFormularioTurno(false);
    } catch (error) {
      console.error('Error al crear tramo:', error);
    }
  };

  const handleUpdateCuadranteComplete = (resultado) => {
    setUpdateResult(resultado);
    // No cerrar el modal - setShowCuadranteUpdater(false);
    // Recargar los turnos del cuadrante después de la actualización
    fetchTurnosCuadrante();
  };

  // Nueva función para ejecutar validación automática
  const ejecutarValidacionAutomatica = async () => {
    try {
      // Importar el validador dinámicamente para evitar dependencias circulares
      const { default: CuadranteValidator } = await import('./config/CuadranteValidator');
      
      // Crear una instancia temporal del validador
      const validatorInstance = {
        validarCuadrante: async () => {
          const { obtenerDatosCuadranteParaValidacion } = await import('./data/FirestoreCuadrantes');
          const datosCuadrante = await obtenerDatosCuadranteParaValidacion(cuadranteId, currentService);
          
          // Ejecutar validaciones
          const configToUse = selectedConfig || {
            nombre: 'Configuración Estándar',
            horasMesConvenio: 160,
            horasExtraMaximas: 20,
            horasMaximasTurno: 12,
            maxKmCambioServicio: 25,
            dietaPorKm: 0.25,
            dietaMinima: 15,
            descansoMinimoEntreTurnos: 11,
            maxJornadasNocturnasConsecutivas: 3,
            descansosFinSemanaMes: 2,
            diasVacaciones: 22,
            descansoTrasTurnosLargos: { horas: 8, turnoMinimo: 6 }
          };
          
          // Ejecutar validaciones básicas
          const errores = [];
          const advertencias = [];
          const resumen = {
            totalTurnos: datosCuadrante.turnos.length,
            turnosValidos: 0,
            turnosConErrores: 0,
            turnosConAdvertencias: 0
          };

          // Validar cada turno
          for (const turno of datosCuadrante.turnos) {
            const turnoErrores = [];
            const turnoAdvertencias = [];

            // Validar horas del mes
            if (turno.horasMes > configToUse.horasMesConvenio + configToUse.horasExtraMaximas) {
              turnoErrores.push(`Excede las horas máximas del mes (${turno.horasMes}h vs ${configToUse.horasMesConvenio + configToUse.horasExtraMaximas}h permitidas)`);
            } else if (turno.horasMes > configToUse.horasMesConvenio) {
              turnoAdvertencias.push(`Aproximándose al límite de horas extra (${turno.horasMes - configToUse.horasMesConvenio}h extra)`);
            }

            // Validar duración del turno
            const calcularDuracionTurno = (inicio, fin) => {
              const [horaInicio, minInicio] = inicio.split(':').map(Number);
              const [horaFin, minFin] = fin.split(':').map(Number);
              
              let duracion = (horaFin * 60 + minFin) - (horaInicio * 60 + minInicio);
              if (duracion < 0) duracion += 24 * 60; // Turno que cruza medianoche
              
              return duracion / 60; // Convertir a horas
            };

            const duracionTurno = calcularDuracionTurno(turno.inicioTurno, turno.finTurno);
            if (duracionTurno > configToUse.horasMaximasTurno) {
              turnoErrores.push(`Turno excede las horas máximas (${duracionTurno}h vs ${configToUse.horasMaximasTurno}h permitidas)`);
            }

            // Validar distancia de transporte
            if (turno.distancia > configToUse.maxKmCambioServicio) {
              const dietaCalculada = Math.max(configToUse.dietaMinima, turno.distancia * configToUse.dietaPorKm);
              turnoAdvertencias.push(`Servicio a ${turno.distancia}km (máximo ${configToUse.maxKmCambioServicio}km). Dieta requerida: ${dietaCalculada.toFixed(2)}€`);
            }

            // Validar disponibilidad
            if (!turno.disponible) {
              turnoErrores.push('Vigilante no disponible (vacaciones, baja, etc.)');
            }

            if (turnoErrores.length > 0) {
              errores.push({
                turnoId: turno.id,
                vigilante: turno.vigilante,
                errores: turnoErrores
              });
              resumen.turnosConErrores++;
            } else {
              resumen.turnosValidos++;
            }

            if (turnoAdvertencias.length > 0) {
              advertencias.push({
                turnoId: turno.id,
                vigilante: turno.vigilante,
                advertencias: turnoAdvertencias
              });
              resumen.turnosConAdvertencias++;
            }
          }

          return {
            esValido: errores.length === 0,
            errores,
            advertencias,
            resumen,
            configuracionUsada: configToUse.nombre,
            fechaValidacion: new Date().toISOString()
          };
        }
      };

      const resultados = await validatorInstance.validarCuadrante();
      setValidationResults(resultados);
      
      // Mostrar notificación si hay errores
      if (!resultados.esValido) {
        console.warn('Validación automática detectó errores en el cuadrante:', resultados.errores);
      }
      
    } catch (error) {
      console.error('Error en validación automática:', error);
    }
  };

  // Función para recargar los turnos del cuadrante
  const fetchTurnosCuadrante = async () => {
    if (!cuadranteId || !currentService) return;
    try {
      const turnos = await obtenerTurnosPorCuadrante(cuadranteId, currentService);
      const eventos = await Promise.all(
        turnos.map(async (turno) => {
          // Crear fechas correctamente
          const [year, month, day] = turno.fecha.split('-');
          const [horaInicio] = turno.inicioTurno.split(':');
          const [horaFin] = turno.finTurno.split(':');
          const start = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(horaInicio));
          const end = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(horaFin));
          if (parseInt(horaFin) < parseInt(horaInicio)) {
            end.setDate(end.getDate() + 1);
          }

          // Verificar si el turno está sin asignar
          const isSinAsignar = turno.sinAsignar || !turno.vigilante || turno.vigilante === '' || turno.vigilante === null || turno.vigilante === undefined;

          if (isSinAsignar) {
            // Para turnos sin asignar
            return {
              id: turno.id,
              title: 'Sin Asignar',
              start: start,
              end: end,
              turno: turno.turno || 'Sin turno',
              vigilante: '',
              vigilanteId: null,
              fecha: turno.fecha,
              inicioTurno: turno.inicioTurno,
              finTurno: turno.finTurno,
              persona: 'Sin asignar',
              sinAsignar: true
            };
          } else {
            // Para turnos asignados
            try {
              const vigilanteData = await obtenerVigilantePorCodigoPersona(turno.vigilante, currentService);
              return {
                id: turno.id,
                title: vigilanteData ? `${vigilanteData.nombre} ${vigilanteData.apellidos}` : `Sin usuario (${turno.vigilante})`,
                start: start,
                end: end,
                turno: turno.turno || 'Sin turno',
                vigilante: turno.vigilante, // Código de persona
                vigilanteId: vigilanteData ? vigilanteData.id : null, // ID de Firestore
                fecha: turno.fecha,
                inicioTurno: turno.inicioTurno,
                finTurno: turno.finTurno,
                persona: vigilanteData ? `${vigilanteData.nombre} ${vigilanteData.apellidos}` : `Código: ${turno.vigilante}`,
                sinAsignar: false
              };
            } catch (error) {
              console.warn("Error procesando turno asignado:", turno, error);
              return {
                id: turno.id,
                title: `Sin usuario (${turno.vigilante})`,
                start: start,
                end: end,
                turno: turno.turno || 'Sin turno',
                vigilante: turno.vigilante,
                vigilanteId: null,
                fecha: turno.fecha,
                inicioTurno: turno.inicioTurno,
                finTurno: turno.finTurno,
                persona: `Código: ${turno.vigilante}`,
                sinAsignar: false
              };
            }
          }
        })
      );
      const eventosValidos = eventos.filter(evento => evento !== null);
      setEvents(eventosValidos);
    } catch (error) {
      console.warn('Error recargando turnos:', error);
    }
  };

  return (
    <div className="cuadrantes">
      <div className="cuadrantesContainer">
        <div className="cuadrantesContent">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px', flexShrink: 0 }}>
            <h1>Gestión de Cuadrantes</h1>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <IconButton
                onClick={(e) => setMostrarMenuConfiguracion(e.currentTarget)}
                size="large"
                sx={{
                  border: '2px solid #0d47a1',
                  borderRadius: '8px',
                  padding: '8px',
                  '&:hover': {
                    backgroundColor: '#e3f2fd'
                  }
                }}
              >
                <span style={{ fontSize: '24px' }}>☰</span>
              </IconButton>
              
              <Menu
                anchorEl={mostrarMenuConfiguracion}
                open={Boolean(mostrarMenuConfiguracion)}
                onClose={() => setMostrarMenuConfiguracion(null)}
              >
                <MenuItem onClick={() => { setShowConfigPanel(!showConfigPanel); setMostrarMenuConfiguracion(null); }}>
                  <span style={{ marginRight: '8px' }}>⚙️</span>
                  {showConfigPanel ? 'Ocultar' : 'Mostrar'} Configuración
                </MenuItem>
                <MenuItem onClick={() => { setShowValidator(!showValidator); setMostrarMenuConfiguracion(null); }}>
                  <span style={{ marginRight: '8px' }}>✅</span>
                  {showValidator ? 'Ocultar' : 'Mostrar'} Validación
                </MenuItem>
                <MenuItem onClick={() => { setShowInstructions(!showInstructions); setMostrarMenuConfiguracion(null); }}>
                  <span style={{ marginRight: '8px' }}>ℹ️</span>
                  {showInstructions ? 'Ocultar' : 'Mostrar'} Instrucciones
                </MenuItem>
                {cuadranteId && (
                  <MenuItem onClick={() => { setShowCuadranteUpdater(!showCuadranteUpdater); setMostrarMenuConfiguracion(null); }}>
                    <span style={{ marginRight: '8px' }}>🔄</span>
                    {showCuadranteUpdater ? 'Ocultar' : 'Mostrar'} Actualizar API
                  </MenuItem>
                )}
                {selectedServicio && (
                  <MenuItem onClick={() => { setShowFreematicaTramos(!showFreematicaTramos); setMostrarMenuConfiguracion(null); }}>
                    <span style={{ marginRight: '8px' }}>📊</span>
                    {showFreematicaTramos ? 'Ocultar' : 'Mostrar'} Tramos Freematica
                  </MenuItem>
                )}
                {cuadranteId && (
                  <MenuItem onClick={() => { setShowAsignacionIA(!showAsignacionIA); setMostrarMenuConfiguracion(null); }}>
                    <span style={{ marginRight: '8px' }}>🤖</span>
                    {showAsignacionIA ? 'Ocultar' : 'Mostrar'} Asignación IA
                  </MenuItem>
                )}
              </Menu>
            </div>
          </div>
          
          {/* Panel de instrucciones */}
          {showInstructions && (
            <div style={{ 
              backgroundColor: '#f8f9fa', 
              padding: '20px', 
              borderRadius: '8px', 
              marginBottom: '20px',
              border: '1px solid #e9ecef',
              flexShrink: 0
            }}>
              <h3 style={{ marginTop: 0, color: '#495057' }}>Instrucciones para gestionar cuadrantes:</h3>
              <ol style={{ color: '#6c757d', lineHeight: '1.6' }}>
                <li><strong>Selecciona un cliente</strong> para el que quieres crear o cargar el cuadrante</li>
                <li><strong>Selecciona un servicio</strong> que aparecerá automáticamente según el cliente elegido</li>
                <li><strong>Haz clic en "Crear/Cargar Cuadrante"</strong> para generar un nuevo cuadrante o cargar uno existente</li>
                <li><strong>Gestiona los turnos</strong> usando las opciones disponibles una vez que el cuadrante esté cargado</li>
              </ol>
            </div>
          )}

          {/* Panel de configuración de cuadrantes */}
          {showConfigPanel && (
            <div style={{ marginBottom: '24px', flexShrink: 0 }}>
              <CuadranteConfig 
                onConfiguracionesChange={setConfiguraciones}
                onConfiguracionSelect={setSelectedConfig}
                selectedConfig={selectedConfig}
              />
            </div>
          )}

          {/* Panel de validación de cuadrantes */}
          {showValidator && (
            <div style={{ marginBottom: '24px', flexShrink: 0 }}>
              <CuadranteValidator 
                cuadranteId={cuadranteId || 'demo-cuadrante'}
                configuracion={selectedConfig}
                onValidationComplete={setValidationResults}
              />
            </div>
          )}

          {/* Panel de actualización de cuadrantes */}
          {showCuadranteUpdater && cuadranteId && (
            <div style={{ marginBottom: '24px', flexShrink: 0 }}>
              <CuadranteUpdater 
                cuadranteId={cuadranteId}
                currentService={currentService}
                onUpdateComplete={handleUpdateCuadranteComplete}
                updateResult={updateResult}
                onClose={() => setShowCuadranteUpdater(false)}
              />
            </div>
          )}

          {/* Panel de tramos de Freematica */}
          {showFreematicaTramos && selectedServicio && (
            <div style={{ marginBottom: '24px', flexShrink: 0 }}>
              <FreematicaTramos 
                currentService={currentService}
                servicioId={selectedServicio}
                onClose={() => setShowFreematicaTramos(false)}
              />
            </div>
          )}

          {/* Panel de Asignación con IA */}
          {showAsignacionIA && cuadranteId && (
            <div style={{ marginBottom: '24px', flexShrink: 0 }}>
              <AsignacionIA 
                cuadranteId={cuadranteId}
                servicioId={selectedServicio}
                clienteId={clienteSeleccionado}
                turnos={events}
                onAsignacionComplete={(asignaciones) => {
                  console.log('Asignaciones completadas:', asignaciones);
                  setShowAsignacionIA(false);
                }}
                onClose={() => setShowAsignacionIA(false)}
              />
            </div>
          )}

          {/* Cargar Cuadrante - estilos similares a Visualizar Cuadrantes, altura para ver tramos sin scroll */}
          <div style={{ 
              marginBottom: '24px', 
              flex: (fetchHorariosResult?.success && filtrosContratos) ? 1 : undefined,
              display: (fetchHorariosResult?.success && filtrosContratos) ? 'flex' : 'block',
              flexDirection: 'column',
              minHeight: (fetchHorariosResult?.success && filtrosContratos) ? 'calc(100vh - 100px)' : undefined
            }}>
              <div style={{ 
                background: 'white',
                padding: '24px', 
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                border: '1px solid #ecf0f1',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                ...((fetchHorariosResult?.success && filtrosContratos) ? { flex: 1 } : {})
              }}>
                <h3 style={{ marginTop: 0, color: '#495057', marginBottom: '20px', fontWeight: '500', flexShrink: 0 }}>
                  Cargar Cuadrante
                </h3>
                
                <div style={{ display: 'flex', gap: '12px', marginBottom: '0', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                  <TextField
                    label="Contrato/Servicio"
                    placeholder="13550/03 o 13550"
                    value={filtrosContratos}
                    onChange={(e) => setFiltrosContratos(e.target.value)}
                    size="small"
                    style={{ minWidth: '180px', flex: '1 1 auto' }}
                  />
                  
                  <TextField
                    select
                    label="Mes"
                    value={mesPersonalizado}
                    onChange={(e) => setMesPersonalizado(Number(e.target.value))}
                    size="small"
                    style={{ minWidth: '120px' }}
                    SelectProps={{ native: true }}
                  >
                    <option value={1}>Enero</option>
                    <option value={2}>Febrero</option>
                    <option value={3}>Marzo</option>
                    <option value={4}>Abril</option>
                    <option value={5}>Mayo</option>
                    <option value={6}>Junio</option>
                    <option value={7}>Julio</option>
                    <option value={8}>Agosto</option>
                    <option value={9}>Septiembre</option>
                    <option value={10}>Octubre</option>
                    <option value={11}>Noviembre</option>
                    <option value={12}>Diciembre</option>
                  </TextField>

                  <TextField
                    select
                    label="Año"
                    value={añoPersonalizado}
                    onChange={(e) => setAñoPersonalizado(Number(e.target.value))}
                    size="small"
                    style={{ minWidth: '100px' }}
                    SelectProps={{ native: true }}
                  >
                    {[2024, 2025, 2026, 2027, 2028].map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </TextField>

                  <FormControl size="small" style={{ minWidth: '250px' }}>
                    <InputLabel id="festivos-label">Ocultar turnos en</InputLabel>
                    <Select
                      labelId="festivos-label"
                      multiple
                      value={tiposFestivosSeleccionados}
                      onChange={(e) => setTiposFestivosSeleccionados(e.target.value)}
                      label="Ocultar turnos en"
                      renderValue={(selected) => {
                        if (selected.length === 0) return 'Ninguno';
                        const labels = {
                          nacionales: '🇪🇸 Festivos',
                          domingos: '📅 Domingos',
                          sabados: '📅 Sábados'
                        };
                        return selected.map(v => labels[v]).join(', ');
                      }}
                    >
                      <MenuItem value="nacionales">
                        <Checkbox checked={tiposFestivosSeleccionados.indexOf('nacionales') > -1} />
                        <span>🇪🇸 Festivos Nacionales</span>
                      </MenuItem>
                      <MenuItem value="domingos">
                        <Checkbox checked={tiposFestivosSeleccionados.indexOf('domingos') > -1} />
                        <span>📅 Domingos</span>
                      </MenuItem>
                      <MenuItem value="sabados">
                        <Checkbox checked={tiposFestivosSeleccionados.indexOf('sabados') > -1} />
                        <span>📅 Sábados</span>
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    padding: '8px 12px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    border: '1px solid #e0e0e0'
                  }}>
                    <Checkbox
                      checked={cargarFestivosFreematica}
                      onChange={(e) => setCargarFestivosFreematica(e.target.checked)}
                      size="small"
                      sx={{ padding: '4px' }}
                    />
                    <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>
                      🎉 Cargar festivos desde Freematica
                    </span>
                  </div>
                  
                  <Button
                    variant="contained"
                    onClick={handleFetchHorariosOperativos}
                    disabled={isFetchingHorarios || !filtrosContratos.trim()}
                    startIcon={isFetchingHorarios && <CircularProgress size={16} />}
                    style={{ minWidth: '120px', height: '40px' }}
                  >
                    {isFetchingHorarios ? 'Cargando...' : 'Cargar'}
                  </Button>
                </div>

                {/* Resultado del fetch */}
                {fetchHorariosResult && (
                  <div style={{ 
                    marginTop: '16px', 
                    padding: '12px 16px', 
                    backgroundColor: fetchHorariosResult.success ? '#d4edda' : '#f8d7da',
                    border: `1px solid ${fetchHorariosResult.success ? '#c3e6cb' : '#f5c6cb'}`,
                    borderRadius: '4px',
                    fontSize: '14px',
                    color: fetchHorariosResult.success ? '#155724' : '#721c24',
                    whiteSpace: 'pre-line'
                  }}>
                    <strong>{fetchHorariosResult.success ? '✓' : '✗'}</strong> {fetchHorariosResult.message}
                  </div>
                )}

                {/* Información de festivos cargados */}
                {festivosInfo && festivosContrato.length > 0 && (
                  <div style={{ 
                    marginTop: '12px', 
                    padding: '12px 16px', 
                    backgroundColor: '#e7f3ff',
                    border: '1px solid #2196f3',
                    borderRadius: '4px',
                    fontSize: '13px'
                  }}>
                    <div style={{ fontWeight: '600', marginBottom: '4px', color: '#1565c0' }}>
                      🎉 Festivos cargados desde Freematica
                    </div>
                    <div style={{ color: '#424242' }}>
                      📋 <strong>Calendario:</strong> {festivosInfo.codigoCalendario}
                      {festivosInfo.descripcion && ` - ${festivosInfo.descripcion}`}
                    </div>
                    <div style={{ color: '#424242' }}>
                      📅 <strong>Total festivos {añoPersonalizado}:</strong> {festivosInfo.totalFestivos}
                    </div>
                    <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                      {festivosContrato.slice(0, 5).map(f => f.descripcion).join(' • ')}
                      {festivosContrato.length > 5 && ` • ...y ${festivosContrato.length - 5} más`}
                    </div>
                  </div>
                )}

                {/* Botones de Exportar/Importar */}
                {cuadranteId && (
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '16px' }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={handleExportarCuadrante}
                    >
                      Exportar Cuadrante
                    </Button>
                    <input
                      type="file"
                      accept=".csv,.txt"
                      onChange={handleFileUploadWrapper}
                      style={{ display: 'none' }}
                      id="import-file"
                    />
                    <label htmlFor="import-file">
                      <Button
                        component="span"
                        variant="outlined"
                        color="secondary"
                        size="small"
                        disabled={isImporting}
                      >
                        {isImporting ? 'Importando...' : 'Importar Cuadrante'}
                      </Button>
                    </label>
                  </div>
                )}

                {/* GridView integrado - ocupa todo el espacio disponible para ver tramos sin scroll */}
                {fetchHorariosResult?.success && filtrosContratos && (
                  <div className="cargar-cuadrante-grid-wrapper" style={{ marginTop: '20px', flex: 1, minHeight: '55vh', overflowX: 'auto', overflowY: 'auto' }}>
                    <GridView 
                      events={events}
                      cuadranteId={cuadranteId}
                      currentService={currentService}
                      servicioId={selectedServicio}
                      onMesChange={handleMesChange}
                      onTurnoActualizado={handleTurnoActualizado}
                      mesInicial={new Date(añoPersonalizado, mesPersonalizado - 1, 1)}
                      tiposFestivosOcultar={tiposFestivosSeleccionados}
                    />
                  </div>
                )}
              </div>
            </div>

          {/* Visualizar Cuadrantes */}
          <div style={{ marginBottom: '24px' }}>
              <div style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '24px', 
                borderRadius: '8px',
                border: '1px solid #dee2e6'
              }}>
                <h3 style={{ marginTop: 0, color: '#495057', marginBottom: '20px', fontWeight: '500' }}>
                  Visualizar Cuadrantes
                </h3>
                
                <VisualizarCuadrantes />
              </div>
            </div>

          {modalOpen && (
            <div className="modal">
              <div className="modal-content">
                <Button className="modal-close" onClick={handleCloseModal}>Cerrar</Button>
                {mostrarFormularioTurno && !eventoTurnoSeleccionado && (
                  <CreateTurno cuadranteId={cuadranteId} currentService={currentService} servicioId={selectedServicio} />
                )}
                {mostrarFormularioTurno && eventoTurnoSeleccionado && (
                  <ActualizarTurno 
                    cuadranteId={cuadranteId} 
                    turnoId={eventoTurnoSeleccionado}
                    currentService={currentService} 
                    onUpdateComplete={handleUpdateTurnoComplete}
                    servicioId={selectedServicio} 
                    onClose={handleCloseModal} 
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <ExportModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        onExport={handleExportWithDesc}
      />
    </div>
  );
};

export default DataCuadrantes;